<script>
export default {
  name: 'SpaRouterView',
};
</script>
<template>
  <router-view />
</template>
